// 自定义语言包
exports.zh = {
//   name: '测试',
//   id: '123',
//   BtnAdd: '新增',
//   BtnDel: '删除'
}
// 报表配置
exports.report = {
  VUE_ROOT_DB: 'sheet_spray_root',
  VUE_GROUP_DB: 'test_group',
  VUE_SHOP_DB: 'test_shop'
}
// 全局变量
exports.newSearchShow = false
